import { Device_Type } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/device_pb.ts';
import { blazeDevicePromiseClient } from '~/services/blaze-device-client';

export const listDeviceStates = async () =>
  await blazeDevicePromiseClient.listDeviceStates({
    typeFilter: Device_Type.SENTIO_CCU,
  });
